import { serializer } from "@/api/shared/serializer";
import firebase from "firebase";
import moment from "moment";

export default {
  name: "GalleryMovePhotosDlg",
  components: {
  },
  data() {
    return {
      dialog: false,
      currentMedia: "",
      isLoading: false,
      selectedFolderId: null,
      photos: [],
      folder: null,
      customFolders: [],
      isCustomFoldersLoading: false
    }
  },
  computed:{
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    photosCount(){
      return this.photos.length
    }
  },
  methods: {
    async open(photos, folder) {
      this.photos = photos
      this.folder = folder
      this.dialog = true;
      await this.loadCustomFolders()
    },
    async loadCustomFolders(){
      this.isCustomFoldersLoading = true
      const snap = await firebase.firestore().collection("galleryFolders").where("facilityId", "==", this.facility.id).get()
      this.customFolders = serializer.querySnapshotToDocuments(snap)
      .filter((x: any)=>x.name !== this.folder.name)
      .sort((a: any, b: any) => moment(a.createdAt.seconds * 1000).diff(moment(b.createdAt.seconds * 1000)))
      
      this.isCustomFoldersLoading = false
    },
    async submit() {
      this.isLoading = true

      const folderId = this.selectedFolderId
      const photosIds = this.photos.map(x=>x.id)

      await this.$store.dispatch("movePhotos", { photosIds, folderId })
      
      this.$emit("onImagesMoved", photosIds);
      this.close()

    },
    close(){
      this.dialog = false
      this.isLoading = false
      this.selectedFolderId = null
      this.photos = []
      this.folder = null
    }
  }
}